import { sharedValidators } from "./shared";

const carValidators = {
  // step 3 → car type
  3: ({ step1 }, t) =>
    !step1.car_type_id ? t("please_select_car_type") : null,

  // step 6 → brand, model, condition, mileage, gearbox, registration year
  6: ({ step1 }, t) => {
    if (!step1.car_brand_id) return t("please_select_brand");
    if (!step1.car_model_id) return t("please_select_model");
    if (!step1.car_condition_id) return t("please_select_condition");
    if (step1.car_condition_id === "2" && step1.mileage > 10000) return t("mileage_under_10000");
    if (!step1.mileage || step1.mileage <= 0) return t("please_enter_mileage");
    if (!step1.gearbox_type?.trim()) return t("please_select_gearbox_type");
    if (!step1.registration_year) return t("please_select_registration_year");
    return null;
  },

  // step 9 → facilities
  9: ({ step2 }, t) =>
    !step2.facilities?.length ? t("please_select_facilities") : null,

  // step 11 → car color
  11: ({ step2 }, t) =>
    !step2.color_theme_id ? t("please_select_color") : null,

  // step 13 → schedules and availability
  13: ({ step3 }, t) => {
    if (!step3.cutoff_time_booking_value || step3.cutoff_time_booking_value < 1)
      return t("please_fill_cutoff_time");

    if (
      !step3.schedules ||
      step3.schedules.length === 0 ||
      step3.schedules.some(({ day, start_time, end_time }) => {
        if (day && (!start_time?.trim() || !end_time?.trim())) return true;
        if (start_time && end_time && start_time >= end_time) return true;
        return false;
      })
    ) {
      return t("please_fill_schedule");
    }

    return null;
  },

  // step 15 → price
  15: ({ step3 }, t) => {
    if (!step3.pricing || step3.pricing.price <= 0) {
      return t("please_enter_valid_price");
    }
    return null;
  },

  // shared validators
  shared: [
    sharedValidators.title,
    sharedValidators.location,
    sharedValidators.summary,
    sharedValidators.description,
    sharedValidators.keyPoints,
    sharedValidators.keywords,
    sharedValidators.images,
    // sharedValidators.cutoffTime,
    sharedValidators.dateRange,
    sharedValidators.cancellationPolicy,
    sharedValidators.bookingConfirmation,
    sharedValidators.applicableDays,
  ],
};

export default carValidators;
